export const QUERY_CLIENT_DEFAULT_OPTIONS = {
  queries: {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  },
};
